// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"_M-z","inlineTitle":"aN-z","sponsoredAdsWrapper":"bN-z","marketplaceRecosWrapper":"cN-z"};